import { render } from "./Advanced.vue?vue&type=template&id=acb1871a&scoped=true"
import script from "./Advanced.vue?vue&type=script&lang=js"
export * from "./Advanced.vue?vue&type=script&lang=js"

import "./Advanced.vue?vue&type=style&index=0&id=acb1871a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb1871a"]])

export default __exports__